module.exports = __webpack_public_path__ + "img/et.9e932a62.svg";